/* eslint-disable react/jsx-handler-names */
import { useState } from "react";
import Collapsible from "react-collapsible";
import classNames from "classnames";

// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import Arrow from "assets/icons/arrowUp.svg?react";

import "./styles.sass";

type TournamentTermsProps = {
  rules: string;
};

const TournamentTerms = (props: TournamentTermsProps) => {
  const { rules } = props;

  const [open, setOpen] = useState(false);

  const t = useTranslate();

  const toggle = () => {
    setOpen(!open);
  };

  const TournamentClass = classNames("TournamentTerms", {
    // eslint-disable-next-line camelcase
    TournamentTerms__open: open,
  });

  const ArrowClass = classNames("TournamentTerms__arrow", {
    // eslint-disable-next-line camelcase
    TournamentTerms__arrow_up: open,
  });

  return (
    <div className={TournamentClass}>
      <div className="TournamentTerms-term" onClick={toggle}>
        <span className="TournamentTerms-term__title">
          {t("tournament.page.rules")}
        </span>
        <Arrow className={ArrowClass} />
      </div>

      <div className="TournamentTerms-list">
        <Collapsible open={open} transitionTime={200} trigger="">
          <div className="TournamentTerms-list__rules">{t(rules)}</div>
        </Collapsible>
      </div>
    </div>
  );
};

export default TournamentTerms;
